<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <!-- Creamos las migas de pan automaticamente -->
        <v-spacer />
        <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16fwIVRI9SzcRK81OVG2WY7C">
            <v-icon>mdi-video</v-icon>
        </v-btn>
      </v-row>

      <v-card elevation="2" shaped>
        <v-card-text>
          <!-- Mensaje informativo -->
          <div class="container_info_azul">
            {{ $t("Activando este servicio, el cliente recibirá un día después de su visita al centro un email para realizar una encuesta de satisfacción donde valorará la calidad del servicio y el trato recibido.") }}
            <ul>
              <li>{{ $t("¿Cómo ha sido el trato recibido por el empleado que le ha atendido?") }}</li>
              <li>{{ $t("Valore el resultado del servicio realizado") }}</li>
              <li>{{ $t("Recomendaría nuestro Centro a un/a amigo/a") }}</li>
              <li>{{ $t("¿Algún comentario para ayudarnos a mejorar?") }}</li>
            </ul>

          </div>
          <v-row class="mx-4">
            <v-col cols="12" sm="6" v-if="configuracion.is_encuestas_email !== null">
              <v-switch :label="$t('Activar encuestas email')" v-model="configuracion.is_encuestas_email"></v-switch>
            </v-col>
            <v-col cols="12" sm="6" v-if="configuracion.is_encuestas_sms !== null">
              <v-switch :label="$t('Activar encuestas SMS')" v-model="configuracion.is_encuestas_sms"></v-switch>
            </v-col>
          </v-row>
        </v-card-text>

        <!-- Boton para guardar la configuración de las encuestas -->
        <v-btn block class="primary" small @click="save_configuracion">
          <v-icon small>mdi-content-save</v-icon>
          <span>{{ $t("Guardar") }}</span>
        </v-btn>
      </v-card>

      <v-expansion-panels focusable class="my-4">
        <v-expansion-panel>
          <v-expansion-panel-header class="titulo_buscador">
            <span>
              <v-icon large>mdi-magnify</v-icon>
              {{ $t("Buscar") }}
            </span>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-form>
              <v-row align="center" class="mt-0">
                <!-- Filtrar por empleado -->
                <v-col cols="12" sm="4" md="3" class="pt-3 pb-0">
                  <CustomSelect
                      v-model="selected_filters.assigned_to"
                      :items="data_filters.empleados"
                      :label="$t('Empleados')"
                      :select_all="true"
                      :hide_details="true"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3" class="pt-3 pb-0">
                  <DatePickerRange
                      v-model="selected_filters.created"
                      :title="$t('Fecha')"
                      dense
                      outlined
                  />
                </v-col>
                <!-- Filtrar por estado de la cita -->
                <v-col cols="12" sm="4" md="3" class="pt-3 pb-0">
                  <CustomSelect
                      v-model="selected_filters.con_comentario"
                      :items="data_filters.con_comentario"
                      :label="$t('Con comentario')"
                      :hide_details="true"
                  />
                </v-col>
                <v-col cols="12" sm="4" md="3" class="pt-3 pb-3 text-end">
                  <v-btn fab small right class="primary" @click="get_encuestas">
                    <v-icon small>mdi-magnify</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <TablaEncuestas
          ref="tabla_encuestas"
          :selected_filters="selected_filters"
          @on_show_encuesta="open_dialog_encuesta"
      />
    </v-container>
  </v-main>
</template>


<script>

export default {
  name: 'Encuestas',
  data: () => ({
    // Formulario
    encuestas_email: false,
    encuestas_sms: false,

    // Variables para rellenar los selects de los filtros
    data_filters: {
      empleados: [],
      con_comentario: []
    },
    // Los filtros seleccionados
    selected_filters: {
      empleados: [],
      con_comentario: [],
      created: []
    },

    configuracion: {
      is_encuestas_sms: null,
      is_encuestas_email: null
    }

  }),
  watch: {
    options: {
      handler (value) {
        let params = {
          limit: value.itemsPerPage,
          offset: ((value.page - 1) * value.itemsPerPage)
        }
        if(value.sortBy.length){
          let desc = value.sortDesc[0] === true ? '-' : ''
          params['ordering'] = `${desc}${value.sortBy[0]}`
        }
        this.get_clientes(params)
      },
      //deep: true,
    },
  },
  methods: {

    /**
     * Recupera los servicios de la api
     */
    async get_encuestas() {
      // Preparamos los filtros del buscador
      this.selected_filters['created__gte'] = this.selected_filters.created[0]
      this.selected_filters['created__lte'] = this.selected_filters.created[1]
      this.selected_filters['assigned_to__in'] = this.selected_filters.empleados.join(',')
      this.selected_filters['is_con_comentario'] = this.selected_filters.con_comentario.join(',')

      await this.$refs.tabla_encuestas.get_encuestas()
    },


    async get_configuracion_encuestas() {
      this.configuracion = await this.$store.dispatch('encuesta/get_configuracion')
    },

    async save_configuracion(){
      try {
        this.configuracion = await this.$store.dispatch('encuesta/save_configuracion', this.configuracion)
        this.$snotify.success(
          this.$t("Acción realizada con éxito"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      } catch (err) {
        this.$snotify.error(
          this.$t("Error al guardar la configuración"),
          this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
        )
      }
    },

    /**
     * Carga los selects para los filtros del buscador
     * @returns {Promise<void>}
     */
    async get_filters() {
      this.data_filters = await this.$store.dispatch('encuesta/get_filters')
      this.data_filters['con_comentario'] = [
        {value: 1, text: this.$t('Si')},
        {value: 0, text: this.$t('No')}
      ]
    },
  },

  mounted(){
    // Asignamos las fechas del filtro
    this.selected_filters.created.push(this.$moment().add(-3, 'months').format('yyyy-MM-DD'))
    this.selected_filters['created__gte'] = this.selected_filters['created'][0]
    this.selected_filters.created.push(this.$moment().format('yyyy-MM-DD'))
    this.selected_filters['created__lte'] = this.selected_filters['created'][1]

    this.get_filters()
    this.get_configuracion_encuestas()
  },

  computed: {
    formatteado(){
      return `${this.dates[0]} ||| ${this.dates[1]}`
    }
  },

  components: {
    TablaEncuestas: () => import("@/views/Marketing/components/TablaEncuestas"),
    DialogVisualizaEncuesta: () => import("@/views/Marketing/components/DialogVisualizaEncuesta")
  }
}
</script>
